export default __webpack_public_path__ + "static/media/goalLight.3c42630f.svg";